/**
 * Operations Equipment Guidance - Simple Direct Pattern
 * Uses requirement ID mapping from operations.simple.js
 */

import { OPERATIONS_GUIDANCE } from "./operations.simple";

/**
 * Get Operations Equipment Guidance
 * @param {string} itemId - Equipment requirement ID
 * @returns {Object|null} Guidance object or null
 */
export function getOperationsGuidance(itemId) {
  // Early return - no debug logging for missing guidance
  return OPERATIONS_GUIDANCE[itemId] || null;
}